import React, { useState } from 'react';
import Navigation from './components/Navigation';
import AboutSection from './components/AboutSection';
import HomeSection from './components/HomeSection';
import ProjectsSection from './components/ProjectsSection';
import BlogSection from './components/BlogSection';
import ProjectDetail from './components/ProjectDetail';
import MathAnimations from './components/MathAnimations';

function App() {
  const [currentSection, setCurrentSection] = useState('home');
  const [selectedProject, setSelectedProject] = useState<any>(null);

  const renderSection = () => {
    if (selectedProject) {
      return (
        <ProjectDetail 
          project={selectedProject} 
          onBack={() => setSelectedProject(null)} 
        />
      );
    }

    switch (currentSection) {
      case 'home':
        return <HomeSection onProjectSelect={setSelectedProject} />;
      case 'about':
        return <AboutSection />;
      case 'projects':
        return <ProjectsSection />;
      case 'blog':
        return <BlogSection />;
      default:
        return <HomeSection onProjectSelect={setSelectedProject} />;
    }
  };

  return (
    <div className="min-h-screen relative">
      {/* Mathematical Background Pattern */}
      <div className="fixed inset-0 math-pattern opacity-5 pointer-events-none" />
      
      {/* Mathematical Animations */}
      <MathAnimations />
      
      {/* Navigation */}
      <Navigation 
        currentSection={currentSection} 
        setCurrentSection={setCurrentSection} 
      />
      
      {/* Main Content */}
      <main className="relative z-10">
        {renderSection()}
      </main>
      
      {/* Footer */}
      <footer className="relative z-10 bg-white border-t border-beige-200 py-8">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <p className="text-gray-600 text-sm mb-2">
              © 2024 Amit Tomar | Built with React and TypeScript.
            </p>
            <p className="font-math text-beige-600 text-xs">
              ∫₀^∞ e^(-x²) dx = √π / 2
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
